import { render, staticRenderFns } from "./auth-forgot-password.vue?vue&type=template&id=50776f4a&"
import script from "./auth-forgot-password.vue?vue&type=script&lang=js&"
export * from "./auth-forgot-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports